// Único lugar permitido con el hex crudo del acento: para casos donde no se puede usar
// var(--accent) porque el navegador exige un literal (p. ej. <input type="color">).
// Mantenido en sync a mano con --accent en src/styles/tokens.css.
export const ACCENT_HEX = "#C2410C";
